<div
  class="flex max-w-[370px] flex-col rounded-[10px] bg-blanco text-start text-cafe shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]">
  <div>
    @if(blogPostInterface.urlImagenPortada) {
      <ln-ln-image-frame
        [src]="blogPostInterface.urlImagenPortada"
        alt="Imagen del producto"
        [class]="'h-[220px] w-full rounded-t-[10px] object-cover'">
      </ln-ln-image-frame>
    }

  </div>
  <div class="px-[18px] py-[15px] text-2xl font-semibold text-verde">
    {{ blogPostInterface.titulo }}
  </div>
  @if(blogPostInterface.texto1) {
    <div class="px-[18px] text-base font-semibold">
      {{ blogPostInterface.texto1 }}
    </div>
  }

  @if(blogPostInterface.texto2) {
  <div class="px-[18px] py-[15px] text-base">
    {{ blogPostInterface.texto2 }}
  </div>
  }
  <div class="flex flex-row mx-[18px] justify-between pb-[18px] items-center">
    <div class="flex text-sm font-normal text-rojizo"> {{'labels.publishedOn' | transloco}}
      {{ formatRawDate(blogPostInterface.createdAt) }}
    </div>
    <div>
      <button class="text-sm font-medium text-verde sm:hover:underline" (click)="navigateToBlogDetails()">
        {{ 'labels.moreInfo' | transloco }}
      </button>
    </div>
  </div>

</div>

